import React from 'react'
import './index.css'
import {Link} from 'react-router-dom'
import {Input, Button, message} from 'antd';
import axios from 'axios';
import {connect} from 'react-redux';
import * as actionCreators from '../../../../../../store/actionCreators'
import md5 from 'blueimp-md5'
import {sm3, sm4} from 'sm-crypto'

class ChangePassword extends React.Component {

    state = {
        username: this.props.user.userName,
        password: '',
        newpasswordVal: "",
        newpsdValvisible: "hidden",
        checkpasswordVal: "",
        newcheckpsdVisible: "hidden",
        claVal: "",

    }


    // axios.post('http://192.168.158.15:8088/app/login' + `?username=${userName}&password=${password}&type=${'WEB'}`, null, { withCredentials: false})

    inputValueChange = (event, flag) => {
        switch (flag) {
            // case 1:
            //   this.setState({
            //     username: event.target.value
            //   })
            //   break;
            case 2:
                this.setState({
                    password: event.target.value
                })
                break;
            case 3:

                this.setState({
                    newpasswordVal: event.target.value,
                    newpsdValvisible: "hidden",
                });

                break;
            case 4:

                this.setState({
                    checkpasswordVal: event.target.value,
                    newcheckpsdVisible: 'hidden'
                });

                break;
            default:
                break
        }
        // console.log(event.target.value,flag)
    }


    // passwordChange = (event) => {
    //   this.setState({
    //     password:event.target.value
    //   })
    // }

    checkChange = async () => {
        if (this.state.newpasswordVal === "") {
            this.setState(
                {
                    claVal: "psdnull",
                    newpsdValvisible: "visible",
                },
                () => console.log(this.state.claVal, this.state.newpsdValvisible)
            );
        } else if (this.state.checkpasswordVal === "") {
            this.setState(
                {
                    claVal: "checkpsdnull",
                    newcheckpsdVisible: "visible",
                },
                () => console.log(this.state.claVal, this.state.newcheckpsdVisible)
            );
        } else if (this.state.newpasswordVal !== this.state.checkpasswordVal) {
            message.error('两次密码输入不一致！', 5)
        } else {
            let {password, newpasswordVal} = this.state;
            // let password = sm3(this.state.username + this.state.password);
            // let passwordkey = Buffer.from(password.slice(0, 16));
            // let encryptedPassword = sm4.encrypt(this.state.password, passwordkey);
            // console.log("loginRequset-----key", key, encryptedPassword);
            // let NewPassword = sm3(this.state.username + this.state.newpasswordVal);
            // let NewPasswordkey = Buffer.from(NewPassword.slice(0, 16));
            // let encryptedNewPassword = sm4.encrypt(this.state.newpasswordVal, NewPasswordkey);
            // console.log("loginRequset-----key", key, encryptedNewPassword);
            // console.log('输入的旧密码', this.state.password, '输入的新密码：', this.state.newpasswordVal);
            // console.log('加密过的旧密码：', encryptedPassword, '加密过的新密码:', encryptedNewPassword)
            console.log('user信息：', this.props.user);
            let params = {
                // name: this.state.username,
                // password: md5(this.state.password),
                // newPassword: md5(this.state.newpasswordVal),
                oldpassword: password,
                password: newpasswordVal,
                // userId: this.props.user.userId,
                name: this.props.user.name,
                // cellphone: '',
                // company: '',
                // duty:''
            }
            // const { data: res } = await axios.post('http://192.168.158.14:10683/omas/user/profile', params,
            //     // { withCredentials: false }
            // )
            let data = new FormData();
            data.append("userinfo", JSON.stringify(params));
            const {data: res} = await axios.post('/yunguanLoginInfoUrl/omas/user/profileImage', data,
                // { withCredentials: false }
            )
            // //接口有问题，还需要和运管沟通
            console.log(res)
            console.log(this.props.user.userId)
            let token = this.props.loginObj.token
            // const { data: res } = await axios.put(`${global.url.sys}/sys/user/updatepswdwithold`, params, { withCredentials: false })
            // console.log(res)
            if (res.code === 1) {
                message.success('密码修改成功！正在跳转登录界面，请稍等……', 5)
                const timer = setTimeout(() => {
                    this.props.LoginIn({tip: '', login: false, token: token})
                    this.props.history.replace('/UserLogin')
                    clearTimeout(timer)
                }, 5000);
            } else {
                message.error('密码修改失败！', 5)
            }
        }
    };

    render() {
        // console.log(this.props.user.userName)
        return (
            <>
                <div className="changePassword-content-top">
                    <Link to="/usercenter/myaccount">
                        <div className="changePassword-content-backimg"></div>
                    </Link>
                    <div className="changePassword-title">密码修改</div>
                </div>
                <div className="changePassword-content-area-wrap">
                    <div className="changePassword-content-area">
                        <div className="changePassword-content">
                            <div className="changePassword-content-item">
                                <p className="changePassword-content-text">用户名</p>
                                <div className="changePassword-content-input">
                                    {/* <Input allowClear placeholder="用户名" onChange={(event)=>this.inputValueChange(event,1)}></Input> */}
                                    <Input allowClear value={this.props.user.userName} disabled></Input>
                                </div>
                            </div>
                            <div className="changePassword-content-item">
                                <p className="changePassword-content-text">账号密码</p>
                                <div className="changePassword-content-input">
                                    <Input.Password
                                        allowClear
                                        placeholder="请输入您的账号密码"
                                        onChange={(event) => this.inputValueChange(event, 2)}
                                        // readOnly={true}
                                        autoComplete='new-password'
                                        value={this.state.password}
                                    ></Input.Password>
                                </div>
                            </div>
                            <div className="changePassword-content-item">
                                <p className="changePassword-content-text">输入新密码</p>
                                <div className="changePassword-content-input">
                                    <Input.Password
                                        allowClear
                                        placeholder="请输入您的账号密码"
                                        onChange={(event) => this.inputValueChange(event, 3)}
                                        // readOnly={true}
                                        autoComplete='new-password'
                                        value={this.state.newpasswordVal}
                                    ></Input.Password>
                                </div>
                            </div>
                            <div className="changePassword-content-item">
                                <p className="changePassword-content-text">
                                    再次确认
                                </p>
                                <div className="changePassword-content-input">
                                    <Input.Password
                                        allowClear
                                        placeholder="再次输入您的账号密码"
                                        onChange={(event) => this.inputValueChange(event, 4)}
                                        // readOnly={true}
                                        autoComplete='new-password'
                                        value={this.state.checkpasswordVal}
                                    ></Input.Password>
                                </div>
                            </div>
                            <div className="checkNewPassword-content-checkchange">
                                <Button
                                    className="checkNewPassword-content-checkchange-button"
                                    onClick={this.checkChange}
                                >
                                    <p className="checkNewPassword-content-checkchange-button-p">
                                        确认修改
                                    </p>
                                </Button>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        );
    }
}

const mapState = (state) => ({
    user: state.userReducer.get('user').toJS(),
    loginObj: state.userReducer.get('loginObj').toJS()
})

const mapDispatch = (dispatch) => ({
    LoginIn: (params) => dispatch(actionCreators.LoginIn(params))
})

export default connect(mapState, mapDispatch)(ChangePassword)